import camelCaseKeys from 'camelcase-keys'
import { ParsedUrlQuery } from 'querystring'
import parameterize from 'parameterize'
import queryString, { ParseOptions } from 'query-string'
import { SearchParams } from 'backend/services/types/urApiService.types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const camelCaseKeysDeep = (obj: any, options = {}) =>
  camelCaseKeys(obj, { deep: true, ...options })

export const slugifyLowercase = (value?: string) => parameterize(value || '')

export const queryParamTransformer = (
  query: ParsedUrlQuery | SearchParams,
  arrayFormat: ParseOptions['arrayFormat'] = 'none',
): SearchParams =>
  queryString.parse(queryString.stringify(query), {
    parseBooleans: true,
    arrayFormat,
  })
